import React from "react";
import { IOS_APP_STORE_URL } from "../utils/appStore";
import { trackDownloadAppClick } from "../utils/posthogEvents";

/**
 * Shared wrapper for every "Download the app" link (docs/analytics-events.md
 * §2.2). Renders a plain external <a> and fires `download_app_clicked` with
 * the given `location` as `button_location`, so future buttons are tracked
 * by default.
 *
 * @param {string} location  §2.2 button_location value (e.g. "home_city_pulse")
 * @param {string} [store]   "apple" | "google" (default "apple")
 * @param {string} [href]    Store URL (default IOS_APP_STORE_URL)
 * @param {number|string} [eventId] Event id when rendered on an event page
 * @param {string} [variant] A/B variant of the surface, when it is being tested
 */
export default function AppStoreLink({
  location,
  store = "apple",
  href = IOS_APP_STORE_URL,
  eventId,
  variant,
  onClick,
  target = "_blank",
  rel = "noopener noreferrer",
  children,
  ...rest
}) {
  const handleClick = (e) => {
    trackDownloadAppClick({ store, buttonLocation: location, eventId, variant });
    if (onClick) onClick(e);
  };

  return (
    <a href={href} target={target} rel={rel} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
